import { default as CE_TrackedUser } from "ce/utils/Analytics/trackedUser";
import { parse } from "tldts";

class TrackedUser extends CE_TrackedUser {
  protected getUserSource(): string {
    const { domain } = parse(window.location.origin);

    if (domain === "appsmithai.com") {
      return "ai_cloud";
    } else {
      return this.selfHosted ? "ee" : "cloud";
    }
  }
}

export default TrackedUser;
